import React from "react";
import { __t } from "../../utils/translate";
import PrimaryButton from "./primaryButton";
import { navigate } from "gatsby";
import { $isLimdiskPopUpClosed } from "../../utils/store";
import { useStore } from "@nanostores/react";

type DiscountPopUpProps = {
    children?: React.ReactNode;
    data?: unknown[];
};

const DiscountPopUp: React.FC<React.PropsWithChildren<DiscountPopUpProps>> = ({ children, data }) => {
    const isLimdiskPopUpClosed = useStore($isLimdiskPopUpClosed);

    const closeDiscountPopUp = () => {
        $isLimdiskPopUpClosed.set(true);
    };

    const handleSelectProducts = () => {
        closeDiscountPopUp();
        navigate("/shop");
    };

    return (
        <>
            {!isLimdiskPopUpClosed && (
                <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black bg-opacity-40">
                    <div className="p-[10px] w-full">
                        <div className="relative bg-white w-full h-fit mx-auto md:max-w-[500px] overflow-auto ">
                            <div className="flex flex-row w-full justify-between items-center py-3 px-5 bg-[#e6f0e4] !text-[15px] text-small-14 text-[#79a862]">
                                <span className="">
                                    {__t("Thank you for shopping with us")}
                                </span>
                                <button
                                    onClick={closeDiscountPopUp}
                                    className="text-[#cbcbcb] hover:text-[#b2b2b2] transition-color duration-300"
                                >
                                    <svg className="" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 32 32">
                                        <path className="fill-current" fillRule="evenodd" clipRule="evenodd" d="M24.9441 8.94289C25.4648 8.42219 25.4648 7.57797 24.9441 7.05727C24.4234 6.53657 23.5792 6.53657 23.0585 7.05727L16.0013 14.1145L8.94411 7.05727C8.42341 6.53657 7.57919 6.53657 7.05849 7.05727C6.53779 7.57797 6.53779 8.42219 7.05849 8.94289L14.1157 16.0001L7.05849 23.0573C6.53779 23.578 6.53779 24.4222 7.05849 24.9429C7.57919 25.4636 8.42341 25.4636 8.94411 24.9429L16.0013 17.8857L23.0585 24.9429C23.5792 25.4636 24.4234 25.4636 24.9441 24.9429C25.4648 24.4222 25.4648 23.578 24.9441 23.0573L17.8869 16.0001L24.9441 8.94289Z" />
                                    </svg>
                                </button>
                            </div>
                            <div className="p-4 flex flex-col items-center">
                                <div className="limdisc-popup__body-label">
                                    <div className="flex flex-row p-5 rotate-[-15deg] color-white">
                                        <div
                                            className="relative w-[35px] before:content-[''] before:absolute before:top-1/2 before:left-1/2 before:-translate-y-1/2 before:-translate-x-1/2 before:rounded-full before:h-[10px] before:w-[10px] before:bg-white">
                                            <svg className="fill-[#083b66] w-full h-full" viewBox="0 0 220 130" preserveAspectRatio="none">
                                                <polygon points="0,65 220,0 220,130"></polygon>
                                            </svg>
                                        </div>
                                        <div className="bg-[#083b66] p-[10px] text-[30px] font-bold leading-[30px] text-white">
                                            20%
                                        </div>
                                    </div>
                                </div>
                                <span className="text-base-16 my-5">{__t('20%')} {__t('discount within 20 minutes')}</span>
                                <PrimaryButton
                                    className="py-4 px-5 uppercase bg-dark-blu"
                                    textStyle="text-h3 font-semibold leading-10"
                                    onClick={handleSelectProducts}
                                >
                                    {__t('Select product')}
                                </PrimaryButton>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};


export default DiscountPopUp;
